import React from 'react';

import wrapStore from '@src/utils/wrap-store';
import { APPOINTMENT_TYPE } from './store';
import ModalContainer from '@src/components/modal-container';
import cx from 'classnames';
import Input from './components/input';
import getPageLocalesData from '@src/global-locales/get-page-locales-data';
import SmsCodeInput from '@src/components/sms-code-input';
import OverseasComponent from './overseas';
import OverseasStore from './overseas/store';
import Link from '@src/components/link';
import LoadingIcon from '@src/pages/main/components/appointment-modal/components/loading-icon';

const pageLocalesData = getPageLocalesData();
const reserveLocalesData = pageLocalesData.reserve;
const styles = require('./index.less');

/**
 * 预约弹窗
 * @param store {AppointmentModalStore}
 * @param onClose
 * @returns {JSX.Element}
 * @constructor
 */
const AppointmentModal = ({ store, onClose }) => {
  store.use();
  store.onClose = onClose;
  /**
   * 渲染预约类型
   * @returns {unknown[]}
   */
  const renderAppointmentTypeRadio = () => {
    const _appointmentTypeArr = Object.keys(APPOINTMENT_TYPE);
    return _appointmentTypeArr.map((item, key) => {
      return (
        <div
          className={cx(styles.typeRadio, store.currentAppointmentType === APPOINTMENT_TYPE[item] && styles.typeRadioActive)}
          onClick={() => store.onSelectAppointmentTypeChange(APPOINTMENT_TYPE[item])}
        >
          <span className={styles.selectIcon} />
          <span className={styles.radioContent}>{item}</span>
        </div>
      );
    });
  };
  const renderSuccess = () => {
    return (
      store.isAppointmentSuccess && (
        <div className={styles.successContainer}>
          <div className={styles.mask} />
          <div className={styles.successContent}>{store.is_new ? reserveLocalesData.logic.has_success : reserveLocalesData.logic.has_repeat}</div>
          <div className={styles.success_tips}>{reserveLocalesData.logic.success_tips}</div>
          <div className={styles.successLine} />
          <div className={styles.countDown}>{getLocales('reserve.logic.auto_close', { second: Math.round(store.countdown / 1000) })}</div>
          <div className="appointment-modal-group-6" data-name="协议">
            <div
              className={cx('appointment-modal-layer-13', store.protocolShaking && styles.shaking)}
              data-name="未注册的手机验证后将自动登录。注册/登录即代表您同意并遵守《西山居用户服务协议》《西山居用户个人用户信息及隐私保护政策》 "
            >
              <div
                className={cx('appointment-modal-layer-14', store.isAgreementProtocol && 'hasAgreed')}
                data-name="单选框"
                onClick={store.onAgreeProtocolChange}
              />
              {getLocalesForHtml('reserve.agreement.desc', {
                arg1: getLocales('reserve.agreement.item1'),
                arg1Link: PROTOCOL[getLanguageByPath()].appointment
              })}
            </div>
          </div>
        </div>
      )
    );
  };

  const renderBtn = () => {
    return (
      <React.Fragment>
        <div className={cx('appointment-modal-layer-9', !store.isLoading && styles.showAppointmentBtn)} data-name="立即预约" />
        <div className={cx(styles.isLoading, store.isLoading && styles.showLoading)}>
          <LoadingIcon />
        </div>
      </React.Fragment>
    );
  };
  return (
    <ModalContainer modalState={store.isOpen}>
      <div className={styles.root}>
        <div className="appointment-modal-root">
          <div className={styles.closeBtn} onClick={store.onCloseHandler} />
          {renderSuccess()}
          <div className="appointment-modal-group-1" data-name="预约弹窗">
            <div className={styles.successModal}>
              <div className="appointment-modal-layer-2" data-name="切换tab " />
              <div className="appointment-modal-group-2" data-name="输入框">
                <div className="appointment-modal-layer-3" data-name="手机号">
                  <Input placeholder={reserveLocalesData.form.phone} store={store.inputStores.phoneInput} />
                </div>
                <div className="appointment-modal-group-3" data-name="验证码">
                  <Input placeholder={reserveLocalesData.form.vcode} store={store.inputStores.smsInput} />
                  <div className={cx(styles.smsBtnBox, store.inputStores.smsInput.isError ? styles.hideSmsBtn : styles.showSmsBtn)}>
                    <SmsCodeInput
                      codeBtnClassName={styles.codeBtn}
                      phone={store.inputStores.phoneInput.valueStore.value}
                      buttonText={reserveLocalesData.form.get_code}
                      sendCode={store.onSendVCRequest}
                      phoneInputValidator={store.phoneInputValidator}
                    />
                  </div>
                </div>
              </div>

              <div className="appointment-modal-group-4" data-name="登录按钮">
                <Link className="appointment-modal-group-5" data-name="组 1" onClick={store.onSubmit}>
                  {renderBtn()}
                  <div className="appointment-modal-layer-10" data-name="右箭头" />
                  <div className="appointment-modal-layer-11" data-name="左箭头" />
                </Link>
                <div className="appointment-modal-layer-12" data-name="分割-line" />
              </div>
              <div className="appointment-modal-group-6" data-name="协议">
                <div
                  className={cx('appointment-modal-layer-13', store.protocolShaking && styles.shaking)}
                  data-name="未注册的手机验证后将自动登录。注册/登录即代表您同意并遵守《西山居用户服务协议》《西山居用户个人用户信息及隐私保护政策》 "
                >
                  <div
                    className={cx('appointment-modal-layer-14', store.isAgreementProtocol && 'hasAgreed')}
                    data-name="单选框"
                    onClick={store.onAgreeProtocolChange}
                  />
                  我已阅读并同意
                  <a className={styles.protocol} href={'//m.xoyo.com/#/protocol?id=4'}>
                    《西山居用户个人用户信息及隐私保护政策》
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </ModalContainer>
  );
};

// export default wrapStore(AppointmentModal, AppointmentModalStore);
export default wrapStore(OverseasComponent, OverseasStore);
